export const formatMinutesToHours = (n, onlyNumbers = false) => {
  const minutes = Math.round(n).toString();

  if (onlyNumbers) {
    return `${minutes}`;
  }

  return `${minutes} min`;
};
